<div class="single-screen layout-spacing">
    <div class="single-screen__upper">
        <ntv-card variant="elevated" rounded="xl" shadow="md">
            <div class="template-preview ntv-card" style="width: 100%; aspect-ratio: 16/9">
                <ntv-template [zones]="myZones" [availablePlaylists]="playlists"></ntv-template>
            </div>
        </ntv-card>
        <ntv-card variant="elevated" rounded="xl" shadow="md">
            <div class="ntv-card screen-info">
                <div class="screen-info__header">
                    <h3>Screen Information</h3>
                    <p>Edit Screen data</p>
                </div>

                <!-- Row 1: Screen Title -->
                <div class="form-row form-row__full">
                    <ntv-input
                        label="Screen Titl dsdse"
                        placeholder="Placeholder"
                        focusBorderColor="#76D2DB"
                        hoverBorderColor="#76D2DB"></ntv-input>
                </div>

                <!-- Row 2: Description -->
                <div class="form-row form-row__full">
                    <ntv-input label="Description" placeholder="Placeholder"></ntv-input>
                </div>

                <!-- Row 3: Screen Type | Published By | Business Name -->
                <div class="form-row form-row__third">
                    <ntv-autocomplete
                        label="Screen Type"
                        [options]="screenTypeOptions"
                        [config]="{ placeholder: 'Placeholder', searchable: true }">
                    </ntv-autocomplete>
                    <ntv-input label="Published By" placeholder="Placeholder"></ntv-input>
                    <ntv-input label="Business Name" placeholder="Placeholder"></ntv-input>
                </div>

                <!-- Row 4: Host | Template -->
                <div class="form-row form-row__half">
                    <ntv-input label="Host" placeholder="Placeholder"></ntv-input>
                    <ntv-input label="Template" placeholder="Placeholder"></ntv-input>
                </div>

                <!-- Row 5: Add Note -->
                <div class="form-row form-row__full">
                    <ntv-input
                        label="Add Note"
                        placeholder="Placeholder"
                        [multiline]="true"></ntv-input>
                </div>
            </div>
        </ntv-card>
    </div>
    <div class="single-screen__lower">
        <ntv-card variant="elevated" rounded="xl" shadow="md">
            <div class="ntv-card template-zones">
                <div class="template-zones__header">
                    <div class="title-group">
                        <h3>NCT standard Template</h3>
                        <p>
                            Below are the zones of NCT Standard Template. Click a Zone to edit its
                            Playlist
                        </p>
                    </div>
                    <ntv-button
                        variant="accent"
                        size="xl"
                        style="--btn-bg: #8cc63f; --btn-hover-bg: #7ab535">
                        Change Template
                    </ntv-button>
                </div>

                <div>
                    <label>Background Zone</label>
                    <ntv-dropdown [config]="mockDropdownConfig"></ntv-dropdown>
                </div>
                <div>
                    <label>Main Zone</label>
                    <ntv-dropdown [config]="mockDropdownConfig"></ntv-dropdown>
                </div>
                <div>
                    <label>Vertical Zone</label>
                    <ntv-dropdown [config]="mockDropdownConfig"></ntv-dropdown>
                </div>
                <div>
                    <label>Horizontal Zone</label>
                    <ntv-dropdown [config]="mockDropdownConfig"></ntv-dropdown>
                </div>
            </div>
        </ntv-card>
        <ntv-card variant="elevated" rounded="xl" shadow="md">
            <div class="ntv-card license-table">
                <div class="license-table__header">
                    <div class="title-group">
                        <h3>Screen Title</h3>
                        <p>Playing in 1 license(s)</p>
                    </div>
                    <div class="button-group">
                        <ntv-button
                            variant="accent"
                            size="xl"
                            style="--btn-bg: #8cc63f; --btn-hover-bg: #7ab535">
                            Unassign Licenses
                        </ntv-button>
                        <ntv-button
                            variant="accent"
                            size="xl"
                            style="--btn-bg: #8cc63f; --btn-hover-bg: #7ab535">
                            Assign Templates
                        </ntv-button>
                    </div>
                </div>

                <app-table
                    [columns]="licenseColumns"
                    [data]="licenseData"
                    [tableTitle]="'Licenses'"
                    [hasCheckBox]="true"
                    tableHeight="400px">
                </app-table>
            </div>
        </ntv-card>
    </div>
</div>
